import { Component, Input, OnInit } from '@angular/core';
import { LocalLoadEvent } from '../../../shared/local-load-event.model';
import { LocalLoadService } from '../../../shared/local-load.service';
import { LoaderService } from '../../../../shared/services/loader.service';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-load-event-pod-upload',
  templateUrl: './load-event-pod-upload.component.html',
  styleUrls: ['./load-event-pod-upload.component.scss']
})
export class LoadEventPodUploadComponent implements OnInit {

  @Input()
  event: LocalLoadEvent;

  constructor(
    private localLoadService: LocalLoadService,
    private loader: LoaderService
  ) {
  }

  ngOnInit() {
  }

  downloadPod() {
    this.loader.startLoad();

    this.localLoadService.downloadPod(this.event.relatedEntityId)
      .pipe(finalize(() => this.loader.stopLoad()))
      .subscribe();
  }

}
